import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { formatPrice } from '../../../../helpers/Text';
import { REDUCER_NAME } from './reducer';
import TextBlinkMalarquee from './TextBlinkMalarquee';

class MaqueItem extends PureComponent {
  formatData = () => {
    const { data, isTicker } = this.props;
    if (!data) {
      return {};
    }
    if (isTicker) {
      return {
        code: data.ticker,
        value: formatPrice(data.matchPrice),
        valueChange: formatPrice(data.priceChange),
        percentChange: data.percentPriceChange,
        referencePrice: formatPrice(data.referencePrice),
        ceilingPrice: formatPrice(data.ceilingPrice),
        floorPrice: formatPrice(data.floorPrice),
      };
    }
    return {
      code: data.comGroupCode,
      value: data.indexValue,
      valueChange: data.indexChange,
      percentChange: data.percentIndexChange,
      referencePrice: data.referenceIndex,
    };
  };

  render() {
    return <TextBlinkMalarquee data={this.formatData()} />;
  }
}

MaqueItem.propTypes = {
  code: PropTypes.string.isRequired,
  isTicker: PropTypes.bool.isRequired,
  data: PropTypes.object,
};

const mapStateToProps = (state, { code }) => ({
  data: state[REDUCER_NAME].headlineData[code],
});

export default connect(mapStateToProps)(MaqueItem);
